import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHHorarioGet = async (credentials, data) => {
  const body = {
    service: "RNHHorarioGet",
    params: {
      rnhHorarioId: data?.id || null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};

